import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faRedo } from '@fortawesome/pro-regular-svg-icons';
import BetterButton from './mellro-primitives/BetterButton';

export default class ErrorBoundary extends React.Component {
	state = { hasError: false };

	static getDerivedStateFromError(_error) {
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		// eslint-disable-next-line no-console
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="text-center p-4">
					<FontAwesomeIcon
						icon={faExclamationTriangle}
						className="text-mellro-danger fs-24px mb-2"
					/>
					<p className="text-mellro-muted fs-14px mb-3">
						{this.props.label || 'Este componente encontrou um problema.'}
					</p>
					<BetterButton
						type="secondary"
						onClick={() => this.setState({ hasError: false })}
					>
						<FontAwesomeIcon icon={faRedo} className="mr-1" />
						Tentar novamente
					</BetterButton>
				</div>
			);
		}
		return this.props.children;
	}
}
